/**
 * Read-only statistics of real, GPS-measured travel times between adjacent stations (RYDE-7994).
 * Pooled over all rides that contain the pair, not only the rides of the entity being edited.
 */
export const getStationTimingPairStatsPath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/station-timing/pair-stats`;
